var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcEditNoCommentImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 10,
    fill: "#002E6C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0759 24.3533L8.66676 25.3333L9.64676 20.9242C9.00137 19.717 8.6647 18.3689 8.66676 17C8.66676 12.3975 12.3976 8.66666 17.0001 8.66666C21.6026 8.66666 25.3334 12.3975 25.3334 17C25.3334 21.6025 21.6026 25.3333 17.0001 25.3333C15.6312 25.3354 14.2831 24.9987 13.0759 24.3533ZM13.3176 22.5925L13.8618 22.8842C14.8272 23.4001 15.9054 23.6689 17.0001 23.6667C18.3186 23.6667 19.6076 23.2757 20.7039 22.5431C21.8002 21.8106 22.6547 20.7694 23.1593 19.5512C23.6639 18.333 23.7959 16.9926 23.5387 15.6994C23.2814 14.4062 22.6465 13.2183 21.7141 12.2859C20.7818 11.3536 19.5939 10.7187 18.3007 10.4614C17.0075 10.2042 15.667 10.3362 14.4489 10.8408C13.2307 11.3454 12.1895 12.1999 11.457 13.2962C10.7244 14.3925 10.3334 15.6814 10.3334 17C10.3334 18.1117 10.6043 19.1817 11.1168 20.1383L11.4076 20.6825L10.8618 23.1383L13.3176 22.5925Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditNoCommentImage);
export default __webpack_public_path__ + "static/media/ic_edit_no_comment_image.ddaa201a75f57279e507af27d01c65cf.svg";
export { ForwardRef as ReactComponent };